// Define all your allowed keys here
export const STORAGE_KEYS = {
  RECENTLY_VIEWED_PROVIDER_ID: 'recentlyViewedProviderId',
} as const;

// Restrict type so only these keys are valid
export type StorageKey = (typeof STORAGE_KEYS)[keyof typeof STORAGE_KEYS];

// Choose storage type
type StorageType = 'session' | 'local';

function getStorage(type: StorageType) {
  return type === 'session' ? sessionStorage : localStorage;
}

export function setItem(key: StorageKey, value: string, type: StorageType) {
  try {
    getStorage(type).setItem(key, value);
  } catch (e) {
    console.error(`Failed to set ${type}Storage key "${key}"`, e);
  }
}

export function getItem(key: StorageKey, type: StorageType): string | null {
  try {
    return getStorage(type).getItem(key);
  } catch (e) {
    console.error(`Failed to read ${type}Storage key "${key}"`, e);
    return null;
  }
}

export function removeItem(key: StorageKey, type: StorageType) {
  try {
    getStorage(type).removeItem(key);
  } catch (e) {
    console.error(`Failed to remove ${type}Storage key "${key}"`, e);
  }
}

export function clearAll(type: StorageType) {
  try {
    getStorage(type).clear();
  } catch (e) {
    console.error(`Failed to clear ${type}Storage`, e);
  }
}
